export enum RoblexCodeStatus {
    initial,
    valid,
    notValid,
}
